<template lang="">
  <el-form
    ref="form"
    :model="form"
    :rules="rule"
    label-width="140px"
    v-loading="loading"
  >
    <!-- <p>
      {{ RenglonID }}
    </p> -->
    <el-form-item v-if="error">
      <p style="color: red">*{{ msg }}</p>
    </el-form-item>
    <el-form-item label="Codigo">
      <el-input v-model="form.AccountNumber" style="width: 30%"></el-input>
    </el-form-item>
    <el-form-item label="Nombre">
      <el-input v-model="form.AccountName"></el-input>
    </el-form-item>

    <el-form-item label="Monto">
      <el-input-number v-model="form.Amount"></el-input-number>
    </el-form-item>

    <el-form-item label="Fecha de ejecución">
      <el-col :span="11">
        <el-date-picker
          type="date"
          placeholder="Fecha"
          v-model="form.PostingDate"
        ></el-date-picker>
      </el-col>
    </el-form-item>

    <el-form-item>
      <el-button @click="close">Cancelar</el-button>
      <el-button type="primary" @click="onSubmit('form')"
        >Agrega Movimiento</el-button
      >
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  name: "ManualEntry",
  events: ["close"],
  props: {
    RenglonID: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      error: false,
      msg: "",
      form: {
        AccountNumber: "",
        AccountName: "",
        Amount: "",
        PostingDate: ""
      },
      rule: {
        AccountNumber: [
          {
            required: true,
            message: "Please input Activity name",
            trigger: "blur"
          }
        ],
        AccountName: "",
        Amount: "",
        PostingDate: ""
      }
    };
  },
  methods: {
    postData() {
      let uri = `/api/CashFlow/AddAccountToRegnlon?rowId=${this.RenglonID}`;
      let params = {
        AccountNumber: this.form.AccountNumber,
        AccountName: this.form.AccountName,
        Amount: this.form.Amount,
        PostingDate: this.form.PostingDate
      };
      this.$http
        .post(uri, params)
        .then(({ data }) => {
          if (data != null) {
            this.$notify.success({
              duration: 5000,
              message: "Movimiento contable agregado al renglón",
              title: "Información",
              position: "top-left"
            });
          }

          this.loadingDetails = false;
        })
        .catch((error) => {
          this.$message.error("Error al consultar los Registros");
          console.error(error);
        })
        .finally(() => {
          this.close();
        });
    },
    onSubmit() {
      this.loading = true;
      if (!this.form.AccountNumber) {
        this.error = true;
        this.msg = "El codigo es requerido";
        this.loading = false;
        return;
      }
      if (!this.form.AccountName) {
        this.error = true;
        this.msg = "El nombre es requerido";
        this.loading = false;
        return;
      }

      if (!this.form.Amount) {
        this.error = true;
        this.msg = "El monto es requerido";
        this.loading = false;
        return;
      }
      this.postData();
    },
    close() {
      this.$refs.form.resetFields();
      this.form = {
        AccountNumber: "",
        AccountName: "",
        Amount: "",
        PostingDate: ""
      };
      this.loading = false;
      this.$emit("close", true);
    }
  }
};
</script>
<style lang=""></style>
